var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarProviderActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2508 0.830078C14.8491 0.830078 15.3491 1.32263 15.2015 1.90245C14.7243 3.77701 13.025 5.16341 11.0019 5.16341C8.97879 5.16341 7.2795 3.77701 6.80227 1.90245C6.65466 1.32264 7.15465 0.830078 7.75296 0.830078C10.2177 0.830078 11.7861 0.830078 14.2508 0.830078Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25189 1.91341C1.25189 1.3151 1.73692 0.830078 2.33523 0.830078H3.41856C4.01687 0.830078 4.50189 1.3151 4.50189 1.91341C4.50189 2.51172 4.01687 2.99674 3.41856 2.99674H2.33523C1.73692 2.99674 1.25189 2.51172 1.25189 1.91341ZM17.5019 1.91341C17.5019 1.3151 17.9869 0.830078 18.5852 0.830078H19.6686C20.2669 0.830078 20.7519 1.3151 20.7519 1.91341C20.7519 2.51172 20.2669 2.99674 19.6686 2.99674H18.5852C17.9869 2.99674 17.5019 2.51172 17.5019 1.91341ZM11.0019 7.33008C11.6002 7.33008 12.0852 7.8151 12.0852 8.41341V9.49675C12.0852 10.0951 11.6002 10.5801 11.0019 10.5801C10.4036 10.5801 9.91856 10.0951 9.91856 9.49675V8.41341C9.91856 7.8151 10.4036 7.33008 11.0019 7.33008Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35126 5.75155C6.77433 6.17461 6.77433 6.86054 6.35126 7.28361L5.53876 8.09611C5.11569 8.51918 4.42976 8.51918 4.00669 8.09611C3.58363 7.67304 3.58363 6.98711 4.00669 6.56405L4.81919 5.75155C5.24226 5.32848 5.92819 5.32848 6.35126 5.75155Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6525 5.75155C15.2295 6.17461 15.2295 6.86054 15.6525 7.28361L16.465 8.09611C16.8881 8.51918 17.574 8.51918 17.9971 8.09611C18.4202 7.67304 18.4202 6.98711 17.9971 6.56405L17.1846 5.75155C16.7615 5.32848 16.0756 5.32848 15.6525 5.75155Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91856 14.9134C9.91856 14.3151 9.43353 13.8301 8.83523 13.8301H4.08812C3.26745 13.8301 2.51721 14.2938 2.1502 15.0278L1.06686 17.1945C0.346554 18.6351 1.39413 20.3301 3.00479 20.3301H8.83523C9.43353 20.3301 9.91856 19.8451 9.91856 19.2467V14.9134Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0852 19.2467C12.0852 19.8451 12.5703 20.3301 13.1686 20.3301H18.999C20.6097 20.3301 21.6573 18.6351 20.937 17.1945L19.8536 15.0278C19.4866 14.2937 18.7364 13.8301 17.9157 13.8301H13.1686C12.5703 13.8301 12.0852 14.3151 12.0852 14.9134V19.2467Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarProviderActive);
export default __webpack_public_path__ + "static/media/solar-provider-active.474bf3a397b7a700b6cb72f2e93cfb26.svg";
export { ForwardRef as ReactComponent };